import React, { useContext } from 'react';
import { useMutation } from '@apollo/client';

import { Context } from '@store/store';
import { getPageToBookmark } from '@utils/getPageToBookmark';
import getTextFromPage from '@utils/getTextFromPage';
import AddBookmarkIcon from '@icons/add-bookmark-icon';

import { StyledAddBookmarkButton } from './add-bookmark-button.styles';

import { GET_ALL_BOOKMARKS, ADD_BOOKMARK } from '@graphql/bookmarks';

const AddBookmarkButton = ({ isMobile }) => {
  const [state, dispatch] = useContext(Context);

  const [addBookmark, { loading, error }] = useMutation(ADD_BOOKMARK, {
    update(cache, { data }) {
      const newBookmarkToAdd = data?.addBookmark;
      const existingBookmarks = cache.readQuery({
        query: GET_ALL_BOOKMARKS,
        variables: {
          id: state.bookId,
        },
      });

      cache.writeQuery({
        query: GET_ALL_BOOKMARKS,
        data: {
          book: {
            bookmarks: [
              ...existingBookmarks?.book?.bookmarks,
              newBookmarkToAdd,
            ],
          },
        },
        variables: {
          id: state.bookId,
        },
      });
    },
    onCompleted: () => {
      dispatch({ type: 'SET_IS_BOOKMARKED', payload: true });
      dispatch({ type: 'SHOW_BOOKMARK_MODAL', payload: true });
    },
  });

  return (
    <StyledAddBookmarkButton
      onClick={() => {
        if (state.isUserLoggedIn) {
          const bookmarkPage = state.isSinglePageMode 
          ? state.currentPage
          : state.currentPage >= state.pagesCount - 1
            ? state.currentPage
            : state.currentPage - 1;
          addBookmark({
            variables: {
              bookId: state.bookId,
              page: bookmarkPage,
              // text: getTextFromPage(state.currentPage), TODO: Здесь неправильная логика
            },
          });
        } else {
          dispatch({
            type: 'TOGGLE_LOGIN_MODAL_VISIBILITY',
            payload: true,
          });
          dispatch({ type: 'WOBBLE_LOGIN_MODAL', payload: true });
        }
      }}
      data-ignore-click-outside="bookmarks-sidebar"
      title="Добавить страницу в закладки"
    >
      <AddBookmarkIcon width={isMobile ? 20 : 28} height={isMobile ? 20 : 28} />
    </StyledAddBookmarkButton>
  );
};

export default AddBookmarkButton;
